(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerOverlay = document.querySelector('.header-overlay');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			if (this.headerIsAlwaysSticky) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.classList.add('always-fixed');
				//if (this.headerOverlay) {
				//	this.headerOverlay.classList.add('color-background-1');
				//	this.headerOverlay.classList.remove('color-inverse');
				//}
			};

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if(scrollTop > this.headerBounds.top && this.headerIsAlwaysSticky) {
				this.headerOverlay?.classList.add('color-background-1');
				this.headerOverlay?.classList.remove('color-inverse');
			}
			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (document.querySelector(".search-modal.active")) return;
			if (document.querySelector(".burger-drawer.active")) {
				this.header.classList.remove('shopify-section-header-hidden', 'animate');
			};
			if (document.querySelector(".burger-drawer.active")) return;
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
			}
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) {
				if (this.headerOverlay) {
					this.headerOverlay.classList.remove('color-background-1');
					this.headerOverlay.classList.add('color-inverse');
				}
				return;
			}

			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.headerOverlay) {
				this.headerOverlay.classList.remove('color-background-1');
				this.headerOverlay.classList.add('color-inverse');
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => {
					disclosure.close(); 
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
				if (this.disclosureLists) {
					this.disclosureLists.forEach(disclosureList => {
						disclosureList.setAttribute('hidden', true); 
					});
				}
			this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
			if (this.disclosureButton) {
				this.disclosureButton.forEach(disclosureButton => {
					disclosureButton.setAttribute('aria-expanded', false); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'input',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	document.addEventListener('DOMContentLoaded', () => {
		const modal = document.querySelector('.product-media-modal__content');

		modal.addEventListener('click', (e) => {
			const media = e.target.closest('img');

			if (!media) return;

			const zoomInContainer = media.nextElementSibling;

			if(!zoomInContainer) return;

			zoomInContainer.classList.add('zoom-in--active');
			const imgcontainer = zoomInContainer.querySelector('img');

			if (!imgcontainer) return;

			zoomInContainer.addEventListener('mousemove', (e) => {
				if (window.innerWidth <= 750) return;
				const rect = imgcontainer.getBoundingClientRect();
				const x = ((e.clientX - rect.left) / rect.width) * 100;
    		const y = ((e.clientY - rect.top) / rect.height) * 100;

				const zoom = 1.5;
				const offsetX = (x - 0.5) * 100;
				const offsetY = (y - 0.5) * 100;
				imgcontainer.style.transform = `scale(${zoom})`;
				imgcontainer.style.transformOrigin = `${x}% ${y}%`;
			});

			zoomInContainer.addEventListener('click', (e) => {
					zoomInContainer.classList.remove('zoom-in--active');
			});

		});
	});

	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			this.initRiadKeshSlider();

			const initialTrack = this.querySelector('[data-rk-related-track]');
			if (initialTrack && initialTrack.querySelector('.popular-products__item')) return;

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
							this.initRiadKeshSlider();
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}

		initRiadKeshSlider() {
			const track = this.querySelector('[data-rk-related-track]');
			const viewport = this.querySelector('[data-rk-related-viewport]');
			const previousButton = this.querySelector('[data-rk-related-prev]');
			const nextButton = this.querySelector('[data-rk-related-next]');

			if (!track || !viewport || !previousButton || !nextButton) return;
			if (track.dataset.rkSliderReady === 'true') return;
			track.dataset.rkSliderReady = 'true';

			const firstCard = track.querySelector('.popular-products__item');
			const firstImage = firstCard ? firstCard.querySelector('img') : null;

			const updateButtons = () => {
				const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
				previousButton.disabled = track.scrollLeft <= 2;
				nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
			};

			const updateArrowPosition = () => {
				if (!firstImage) return;
				const viewportRect = viewport.getBoundingClientRect();
				const imageRect = firstImage.getBoundingClientRect();
				if (imageRect.height <= 0) return;
				const imageCenter = imageRect.top - viewportRect.top + imageRect.height / 2;
				viewport.style.setProperty('--rk-related-arrow-top', `${imageCenter}px`);
			};

			const updateLayout = () => {
				updateButtons();
				updateArrowPosition();
			};

			const cardWidth = () => {
				const card = track.querySelector('.popular-products__item');
				return card ? card.getBoundingClientRect().width : track.clientWidth;
			};

			const move = (direction) => {
				track.scrollBy({
					left: cardWidth() * direction,
					behavior: 'smooth',
				});
			};

			previousButton.addEventListener('click', () => move(-1));
			nextButton.addEventListener('click', () => move(1));
			track.addEventListener('scroll', () => window.requestAnimationFrame(updateButtons), {
				passive: true,
			});

			let isDragging = false;
			let dragStartX = 0;
			let dragStartScroll = 0;
			let dragDistance = 0;
			let suppressClick = false;
			let activePointerId = null;

			track.addEventListener('pointerdown', (event) => {
				if (event.pointerType !== 'mouse' || event.button !== 0) return;
				isDragging = true;
				activePointerId = event.pointerId;
				dragStartX = event.clientX;
				dragStartScroll = track.scrollLeft;
				dragDistance = 0;
				suppressClick = false;
				track.setPointerCapture(event.pointerId);
			});

			track.addEventListener('pointermove', (event) => {
				if (!isDragging || event.pointerId !== activePointerId) return;
				const distance = event.clientX - dragStartX;
				dragDistance = Math.max(dragDistance, Math.abs(distance));
				if (dragDistance > 4) {
					suppressClick = true;
					track.classList.add('is-dragging');
					event.preventDefault();
				}
				track.scrollLeft = dragStartScroll - distance;
			});

			const finishDrag = (event) => {
				if (!isDragging || event.pointerId !== activePointerId) return;
				isDragging = false;
				if (track.hasPointerCapture(event.pointerId)) {
					track.releasePointerCapture(event.pointerId);
				}
				track.classList.remove('is-dragging');

				if (suppressClick) {
					const width = cardWidth();
					const destination = width > 0 ? Math.round(track.scrollLeft / width) * width : track.scrollLeft;
					track.scrollTo({ left: destination, behavior: 'smooth' });
				}
				activePointerId = null;
			};

			track.addEventListener('pointerup', finishDrag);
			track.addEventListener('pointercancel', finishDrag);
			track.addEventListener('click', (event) => {
				if (!suppressClick) return;
				event.preventDefault();
				event.stopImmediatePropagation();
				suppressClick = false;
			}, true);
			track.addEventListener('dragstart', (event) => event.preventDefault());

			if (firstImage && !firstImage.complete) {
				firstImage.addEventListener('load', updateArrowPosition, { once: true });
			}

			if ('ResizeObserver' in window) {
				const resizeObserver = new ResizeObserver(updateLayout);
				resizeObserver.observe(track);
				if (firstCard) resizeObserver.observe(firstCard);
			} else {
				window.addEventListener('resize', updateLayout);
			}

			updateLayout();
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riadkesh-discount-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('discount-popup')) {
    class DiscountPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('[data-popup-close]');
        this.copyButton = this.querySelector('[data-popup-copy]');
        this.ctaButton = this.querySelector('[data-popup-cta]');
        this.status = this.querySelector('[data-popup-status]');
        this.delay = Number(this.dataset.delay) || 8000;
        this.storageKey = 'riadkesh-discount-popup-shown';
        this.designMode = this.dataset.designMode === 'true';
        this.isReload = this.getNavigationType() === 'reload';

        if (!this.dialog) return;

        this.closeButton?.addEventListener('click', () => this.close());
        this.ctaButton?.addEventListener('click', () => this.close());
        this.copyButton?.addEventListener('click', () => this.copyCode());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open(true);
        });

        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close();
        });

        if (this.designMode) return;
        if (!this.isReload && this.wasShownDuringVisit()) return;

        this.timer = window.setTimeout(() => this.open(), this.delay);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
      }

      open(force = false) {
        if (!this.dialog || this.dialog.open) return;
        if (!force && !this.designMode && !this.isReload && this.wasShownDuringVisit()) return;
        this.dialog.showModal();
        this.rememberShown();
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
      }

      rememberShown() {
        if (this.designMode) return;
        try {
          sessionStorage.setItem(this.storageKey, 'true');
        } catch (error) {
          return;
        }
      }

      wasShownDuringVisit() {
        try {
          return sessionStorage.getItem(this.storageKey) === 'true';
        } catch (error) {
          return false;
        }
      }

      getNavigationType() {
        const navigation = performance.getEntriesByType('navigation')[0];
        if (navigation?.type) return navigation.type;
        if (performance.navigation?.type === 1) return 'reload';
        return 'navigate';
      }

      async copyCode() {
        if (!this.copyButton) return;
        const code = this.copyButton.dataset.code || '';
        const copiedLabel = this.copyButton.dataset.copiedLabel || '';
        const defaultLabel = this.copyButton.dataset.defaultLabel || '';

        try {
          await navigator.clipboard.writeText(code);
          this.copyButton.textContent = copiedLabel;
          if (this.status) this.status.textContent = copiedLabel;
          window.setTimeout(() => {
            this.copyButton.textContent = defaultLabel;
          }, 1800);
        } catch (error) {
          this.copyButton.textContent = code;
          if (this.status) this.status.textContent = code;
        }
      }
    }

    customElements.define('discount-popup', DiscountPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
